/**
 * Step 5 In funnel
 * View and print report
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom"; 
import { useSelector, useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import {
  AppBar, Toolbar, Typography, Drawer, Box, Select, MenuItem, Stack,
  FormControl, TextField, InputLabel, Button, IconButton,
  Grid, Card, CssBaseline, Container, Checkbox,
  Tabs, Tab, ButtonGroup, Menu,
  List, ListItem, ListItemText, ListItemAvatar, ListItemButton, Divider, Avatar
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import html2canvas from 'html2canvas';

import Header from '../../components/Header';

import {
  getSurveysIntersectingCylinder,
  metersToDegrees,
  generateSimpleDirectionalSurvey,
  generateFpzPolygon
} from '../../common/functions';
import { fpzActions } from '../../actions';
import AppShell from '../../components/Layout/AppShell';

const drawerWidth = 240;

const containerStyle = {
  width: '100vw',
  height: '100vh',
  position: 'relative'
};

const mapContainerStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1
};

const ReportPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authState = useSelector(state => state.authReducer);
  const userState = useSelector(state => state.userReducer);
  const { user } = userState;

  const [fpzReports, setFpzReports] = useState([]);

  const fetchFpzReports = async () => {
    const params = {
      user_id: authState?.profile?.userId,
    }
    const response = await fpzActions.getFpzReports(params);
    if (response) {
      console.log('Fetched FPZ Reports:', response);
      setFpzReports(response);
    }
  };

  useEffect(() => {

    fetchFpzReports();

    
  }, []);

  const handleViewReport = async (fpzReport) => {
    console.log('View Report:', fpzReport);
    if (!fpzReport) {
      console.error('No report details found');
      return;
    }
    await dispatch({
      type: 'SET_CURRENT_FPZ_REPORT', payload: {
        ...fpzReport?.report_details,
        fpz_report_id: fpzReport?.fpz_report_id || null,
        report_name: fpzReport?.report_name || '', 
        report_description: fpzReport?.report_description || ''
      }
    });
    navigate(`/report`);
  };

  return (
    <Box
        sx={{
        //mt: 15,
        padding: 4,
        borderRadius: 2,
        boxShadow: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" mb="15px"  gutterBottom>
        Profile Information
      </Typography>
      
      { /* Contact Information */}
      <Stack spacing={3}>
        <TextField
          label="Name"
          value={`${user?.user_first_name} ${user?.user_last_name}` || ''}
          fullWidth
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
        />
        <TextField
          label="Email"
          value={user?.user_email || ''}
          fullWidth
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
        />
        <TextField
          label="Phone"
          value={user?.user_phone || ''}
          fullWidth
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
        />

        <Button onClick={() => {}}>Save</Button>
      </Stack>
    </Box>

  );
};

export default ReportPage;
